function accordion()
{
    const accordionHeader = document.querySelectorAll('footer .accordion-header');
    const accordionAnswer = document.querySelectorAll('footer .accordion-answer');

    if (window.innerWidth < 1024) {
        accordionHeader.forEach(function (header) {
            header.addEventListener('click', function () {
                if (this.classList.contains('open')) {
                    this.classList.remove('open');
                    this.nextElementSibling.style.display = 'none';
                } else {
                    accordionHeader.forEach(function (otherHeader) {
                        otherHeader.classList.remove('open');
                    });
                    this.classList.add('open');

                    accordionAnswer.forEach(function (answer) {
                        answer.style.display = 'none';
                    });
                    this.nextElementSibling.style.display = 'block';
                }
            });
        });
    }

    let accordions = document.querySelectorAll('.accordion .accordion-header');

    if (accordions.length) {
        for (let accordion of accordions) {
            accordion.addEventListener('click', function () {

                accordion.classList.toggle('open')
                accordion.nextElementSibling.classList.toggle('collapse-show')
            });
        }
    }

}

export { accordion };